import React, { useState } from 'react';
import ArrayBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ArrayBuilder';
import { Icon, SelectMenu } from '@scale/scaleui';
import {
  ThresholdSBQRatePairSchema,
  ThresholdQualityMeasurementSchema,
} from '@scale/shared/pipelinev3/genai';
import {
  MetricBasedSamplingRoutingOverrideVariableType,
  ThresholdSBQRatePair,
  ThresholdQualityMeasurement,
} from '@scale/shared-types';
import type { TypeBuilderMapType } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemasType';

interface MetricBasedSamplingOverrideVariablesBuilderProps {
  name: string;
  existingValue?: Array<ThresholdSBQRatePair | ThresholdQualityMeasurement>;
  updateProperty: (
    arg: Array<ThresholdSBQRatePair | ThresholdQualityMeasurement> | undefined,
  ) => void;
  required?: boolean;
  typeBuilderMap: TypeBuilderMapType;
}

const variableTypeOptions = [
  {
    id: MetricBasedSamplingRoutingOverrideVariableType.ThresholdSBQRatePair,
    name: 'SBQ Rate and Thresholds',
  },
  {
    id: MetricBasedSamplingRoutingOverrideVariableType.ThresholdQualityMeasurement,
    name: 'Quality Measurement and Thresholds ',
  },
];

const MetricBasedSamplingOverrideVariablesBuilder: React.FC<
  MetricBasedSamplingOverrideVariablesBuilderProps
> = ({ name, existingValue = [], updateProperty, typeBuilderMap }) => {
  const variables = existingValue;
  const [selectedType, setSelectedType] = useState<MetricBasedSamplingRoutingOverrideVariableType>(
    MetricBasedSamplingRoutingOverrideVariableType.ThresholdSBQRatePair,
  );

  const addVariable = (type: MetricBasedSamplingRoutingOverrideVariableType) => {
    const newVariables = [...variables];
    newVariables.push({ type, variable: '' } as any);
    updateProperty(newVariables);
  };

  return (
    <div className="scaleui scaleui-tailwind scale-theme">
      {name && <div className="my-2 text-sm font-medium leading-6 text-neutral-700">{name}</div>}
      <ArrayBuilder
        typeBuilderMap={typeBuilderMap}
        elements={variables}
        setElements={updateProperty}
        getKey={variable => JSON.stringify(variable)}
        getTitle={variable => `${variable.type}`}
        getSchema={variable => {
          if (
            variable.type === MetricBasedSamplingRoutingOverrideVariableType.ThresholdSBQRatePair
          ) {
            return ThresholdSBQRatePairSchema;
          } else {
            return ThresholdQualityMeasurementSchema;
          }
        }}
      />
      <div className="flex">
        <SelectMenu
          className="min-w-[135px]"
          options={variableTypeOptions}
          selectedOptionId={selectedType}
          setSelected={value => {
            setSelectedType(value as MetricBasedSamplingRoutingOverrideVariableType);
          }}
        />
        <Icon
          className="ml-4"
          hasBackground
          icon={['fas', 'plus']}
          onClick={() => addVariable(selectedType)}
          size="lg"
          variant="primary"
        />
      </div>
    </div>
  );
};

export default MetricBasedSamplingOverrideVariablesBuilder;
